import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDemoRequest } from "./DemoRequest";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { open } = useDemoRequest();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "Products", href: "/products" },
    { label: "Solutions", href: "/solutions" },
    { label: "Bespoke", href: "/bespoke" },
    { label: "Pricing", href: "/pricing" },
    { label: "About", href: "/about" },
    { label: "Contact", href: "/contact" },
  ];

  const isActive = (href: string) => {
    if (href === "/") return location.pathname === "/";
    return location.pathname === href;
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black border-b border-graphite-700/50"
          : "bg-gradient-to-b from-black via-black/90 to-transparent"
      }`}
    >
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="flex items-center justify-between h-[88px] md:h-[120px]">
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <img
              alt="StackMap Systems"
              className="h-[84px] md:h-[116px] w-auto object-contain"
              src="https://public.readdy.ai/ai/img_res/bb18d063-181d-43b7-ad64-6d8566caa367.png"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) =>
              link.href.startsWith("/#") ? (
                <a
                  key={link.label}
                  href={link.href}
                  className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                    isActive(link.href)
                      ? "text-emerald-accent bg-emerald-accent/10"
                      : "text-silver-300 hover:text-white"
                  }`}
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.href}
                  className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                    isActive(link.href)
                      ? "text-emerald-accent bg-emerald-accent/10"
                      : "text-silver-300 hover:text-white"
                  }`}
                >
                  {link.label}
                </Link>
              )
            )}
          </div>

          <div className="flex items-center gap-3">
            <button onClick={open} className="hidden md:inline-flex btn-primary text-sm cursor-pointer">
              Book a Demo
            </button>
            <button
              className="lg:hidden w-10 h-10 flex items-center justify-center text-white"
              aria-label="Toggle menu"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <i className="ri-menu-line text-2xl" />
            </button>
          </div>
        </div>
      </div>

      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-black border-t border-graphite-700/50 px-4 py-4 space-y-1">
          {navLinks.map((link) =>
            link.href.startsWith("/#") ? (
              <a
                key={link.label}
                href={link.href}
                className={`block px-4 py-3 text-sm font-medium rounded-md transition-colors ${
                  isActive(link.href)
                    ? "text-emerald-accent bg-emerald-accent/10"
                    : "text-silver-300 hover:text-white hover:bg-graphite-800/50"
                }`}
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.href}
                className={`block px-4 py-3 text-sm font-medium rounded-md transition-colors ${
                  isActive(link.href)
                    ? "text-emerald-accent bg-emerald-accent/10"
                    : "text-silver-300 hover:text-white hover:bg-graphite-800/50"
                }`}
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            )
          )}
          <button onClick={open} className="block w-full text-center btn-primary text-sm mt-2 cursor-pointer">
            Book a Demo
          </button>
        </div>
      </div>
    </nav>
  );
}
